//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


const EXPORT_TYPES = ['csv', 'ods', 'xlsx'];

export default {

	data()
	{
		return {
			selectedRows: [],
			page: window.location.pathname
		};
	},

	mounted()
	{
		this.eventBus.$on('onSelectedRowsChanged', selectedRows => this.selectedRows = selectedRows);

		this.eventBus.$on('afterRequest', () => {
			this.page = window.location.pathname + window.location.search;
		});

		$(this.$refs.actions).on('click', event => {
			event.stopPropagation();
		});
	},

	computed: {

		options()
		{
			return this.$store.getters[`${this.$root.$namespace}/getToolbarOptions`];
		},

		eventBus()
		{
			return this.$root.$eventBus || this;
		},

		canBuySelectedRows()
		{
			return this.selectedRows.filter(row => (row.products[row.selected] || {}).canBuy);
		},

		localize()
		{
			return Object.freeze({
				'addtobasket': BX.message('RS.B2BPORTAL.ADD_TO_BASKET_LABEL'),
				'actions': BX.message('RS.B2BPORTAL.ACTIONS_LABEL'),
				'settings': BX.message('RS.B2BPORTAL.SETTINGS_LABEL'),
				'switcher': BX.message('RS.B2BPORTAL.IMAGE_SWITCHER_LABEL'),
				'export': BX.message('RS.B2BPORTAL.EXPORT_LABEL')
			})
		},

		labelAddtobasket()
		{
			return this.localize.addtobasket.replace('#COUNT#', this.canBuySelectedRows.length)
		},

		previewSwitcher()
		{
			return this.$store.getters[`${this.$root.$namespace}/isShowPreview`];
		},

		exports()
		{
			if (!this.options.export)
				return [];

			return this.options.exportTypes.filter(type => EXPORT_TYPES.includes(type)).map(type => {
				const uri = new BX.Uri((this.page || ''));
				uri.setQueryParam('export', type);

				return {
					name: type,
					url: uri.toString()
				};
			});
		},

		isShowActions()
		{
			return this.options.previewSwitcher || this.exports.length > 0;
		},

		spritePath()
		{
			return B2BPortal.config.spritePath;
		},
	},

	methods: {

		addtobasket()
		{
			if (!this.selectedRows.length)
				return;

			this.$emit('addtobasket', this.selectedRows);
		},

		togglePreviewSwitcher()
		{
			this.$store.dispatch(`${this.$root.$namespace}/togglePreview`);
		}
	},
}
